/* RESPONSIBLE TEAM: team-inbox */

export const ARTICLES_SURVEY_ID = '29881657';

export type AiAssistSettingsResponse = {
  inbox: boolean;
  conversation_summarization: boolean;
  text_transformations: boolean;
  auto_fill_tickets: boolean;
  articles: boolean;
  copilot: boolean;
};

export const SUPPORTED_LANGUAGES = [
  'arabic',
  'armenian',
  'azerbaijani',
  'bengali',
  'bosnian',
  'brazilian-portuguese',
  'bulgarian',
  'catalan',
  'croatian',
  'czech',
  'danish',
  'dutch',
  'english',
  'estonian',
  'finnish',
  'french',
  'georgian',
  'german',
  'formal-german',
  'greek',
  'hebrew',
  'hindi',
  'hungarian',
  'indonesian',
  'italian',
  'japanese',
  'korean',
  'latvian',
  'lithuanian',
  'malay',
  'mongolian',
  'norwegian',
  'persian',
  'polish',
  'portuguese',
  'romanian',
  'russian',
  'serbian',
  'simplified-chinese',
  'sinhala',
  'slovak',
  'slovenian',
  'spanish',
  'swahili',
  'swedish',
  'tamil',
  'thai',
  'traditional-chinese',
  'turkish',
  'ukrainian',
  'urdu',
  'vietnamese',
] as const;
